import { render, staticRenderFns } from "./TraxAccountUserCrudForm.vue?vue&type=template&id=523ce14e"
import script from "./TraxAccountUserCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports